import { render } from "./NavMenu.vue?vue&type=template&id=21d260ee&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=21d260ee&lang=scss&scoped=true"

import exportComponent from "D:\\workpace\\yt-portal-layout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d260ee"]])

export default __exports__